import RenewedEngagements from '@dashboardWirelineRetentionDepartment/RenewedEngagements/RenewedEngagements';

export default RenewedEngagements;
